import { Routes } from '@angular/router';
import { authGuard, oauthRoutes, settingsRoutes, tenantGuard, tenantRoutes } from '@cmi/addin-core';
import { FiledView } from './home/filed/filed-view';
import { FilingFlow } from './home/filing/filing-flow';
import { Home } from './home/home';
import { openMailGuard } from './home/open-mail.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [tenantGuard, authGuard],
    component: Home,
    children: [
      // The entry point, and where Home sends every mail change: redirects to
      // one of the pages below, depending on the selection and the open mail's
      // record.
      { path: '', pathMatch: 'full', canActivate: [openMailGuard], children: [] },
      { path: 'file', component: FilingFlow },
      { path: 'filed', component: FiledView },
      // Loaded on demand: only multi-select needs it, and the initial bundle has a budget.
      {
        path: 'batch',
        loadComponent: () => import('./home/batch/batch-view').then((m) => m.BatchView)
      },
      // Nothing selected: an empty page, Home says so.
      { path: 'none', children: [] }
    ]
  },
  ...settingsRoutes(),
  ...tenantRoutes,
  ...oauthRoutes
];
